<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <!-- Header -->
        <v-card class="elevation-4 mb-4 mx-auto" color="primary" dark>
          <v-card-text class="d-flex align-center pa-4">
            <v-icon size="32" class="mr-3">mdi-clipboard-list</v-icon>
            <div>
              <h2 class="mb-1">Questionários Disponíveis</h2>
              <p class="text-caption mb-0">Selecione um questionário para responder</p>
            </div>
          </v-card-text>
        </v-card>

        <!-- Back Button -->
        <v-btn color="primary" class="mb-4" @click="voltarParaLogin">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>

        <!-- Lista de Questionários -->
        <div>
          <v-card
            v-for="(item, index) in disponivel"
            :key="`questionario-${index}`"
            class="elevation-4 mb-4 mx-auto"
            :color="item.respondido == 1 ? 'success' : 'white'"
          >
            <v-card-title class="d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-avatar :color="item.respondido == 1 ? 'success' : 'primary'" size="40" class="mr-3">
                  <v-icon color="white">
                    {{ item.respondido == 1 ? 'mdi-check-circle' : 'mdi-clipboard-text' }}
                  </v-icon>
                </v-avatar>
                <div>
                  <h3 class="mb-0">{{ item.nome }}</h3>
                  <p class="text-caption mb-0">ID: {{ item.id_questionario }}</p>
                </div>
              </div>
              <v-chip :color="item.respondido == 1 ? 'success' : 'warning'" small>
                {{ item.respondido == 1 ? 'Respondido' : 'Pendente' }}
              </v-chip>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8">
                  <div class="mb-3">
                    <h4>
                      <v-icon left color="primary">mdi-account</v-icon>
                      Informações Pessoais
                    </h4>
                    <div>
                      <div><strong>Nome:</strong> {{ item.nome }}</div>
                      <div v-if="item.aluno"><strong>CGM:</strong> {{ item.cgm }}</div>
                      <div v-if="item.cpf"><strong>CPF:</strong> {{ formatCpf(item.cpf) }}</div>
                    </div>
                  </div>
                  <div>
                    <h4>
                      <v-icon left color="primary">mdi-school</v-icon>
                      Instituição
                    </h4>
                    <div>
                      <div><strong>Nome:</strong> {{ item.instituicao }}</div>
                      <div><strong>ID:</strong> {{ item.id_instituicao }}</div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column align-center justify-center">
                  <div class="mb-2">
                    <v-icon :color="item.respondido == 1 ? 'success' : 'warning'" size="24">
                      {{ item.respondido == 1 ? 'mdi-check-circle' : 'mdi-clock-outline' }}
                    </v-icon>
                    <div>
                      <strong>{{ item.respondido == 1 ? 'Concluído' : 'Pendente' }}</strong>
                      <small>{{ item.respondido == 1 ? 'Questionário já respondido' : 'Aguardando resposta' }}</small>
                    </div>
                  </div>
                  <v-btn v-if="item.respondido == 0" block color="success" class="mt-2" large elevation="2" @click="responderQuestionario(item)">
                    <v-icon left>mdi-play-circle</v-icon>
                    Responder Agora
                  </v-btn>
                  <v-btn v-else block color="grey" class="mt-2" large disabled elevation="0">
                    <v-icon left>mdi-check</v-icon>
                    Já Respondido
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>

        <!-- Estado Vazio -->
        <v-card v-if="!disponivel || disponivel.length === 0" class="elevation-4 mx-auto mt-8">
          <v-card-text class="text-center pa-8">
            <v-icon color="grey" size="64">mdi-clipboard-text-off</v-icon>
            <h3 class="mt-4 mb-2">Nenhum questionário disponível</h3>
            <p>Não há questionários pendentes para responder no momento.</p>
            <v-btn color="primary" @click="voltarParaLogin" class="mt-4">
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar ao Início
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'QuestionariosDisponiveis',
  computed: {
    ...mapGetters({ param: 'avaliacao/param' }),
    disponivel() {
      return this.param && this.param.disponivel ? this.param.disponivel : [];
    },
  },
  methods: {
    ...mapMutations({ setPessoa: 'avaliacao/setPessoa' }),
    formatCpf(cpf) {
      if (!cpf) return '';
      const numbers = cpf.replace(/\D/g, '');
      if (numbers.length === 11) {
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
      return cpf;
    },

    voltarParaLogin() {
      // Limpar dados disponíveis ao voltar
      this.param.disponivel = [];
      if (this.$route.path !== '/login') this.$router.push('/login');
    },

    responderQuestionario(item) {
      // Adaptar o objeto para o formato esperado pelo sistema

      const adaptedItem = {
        nome: item.nome,
        instituicao: item.instituicao,
        id_instituicao: item.id_instituicao,
        id_questionario: item.id_questionario,

        cgm: item.cgm,
        cpf: item.cpf,
        avaliado: item.respondido,
        apto: 1,
      };

      this.setPessoa(adaptedItem);
      this.$router.push('/questionario');
    },
  },
};
</script>

<style scoped>
.questionarios-disponiveis {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 20px 0 64px 0;
}
@media (max-width: 960px) {
  .questionarios-disponiveis {
    padding: 8px 0 64px 0;
  }
  .v-card {
    margin-left: auto !important;
    margin-right: auto !important;
    width: 98vw !important;
    min-width: 0 !important;
    max-width: 100vw !important;
    transition: width 0.3s;
  }
  .v-card-title,
  .v-card-text {
    padding-left: 8px !important;
    padding-right: 8px !important;
    transition: padding 0.3s;
  }
  .v-btn {
    font-size: 0.95rem !important;
    padding: 8px 0 !important;
    transition: font-size 0.3s, padding 0.3s;
  }
  h2,
  h3,
  h4 {
    font-size: 1.1rem !important;
    transition: font-size 0.3s;
  }
}
</style>
